<section class="main-page">
  <div class="bg"></div>

  <div class="wrapper" [class.has-selected]="hasSelected()">
    <app-chat-list
      (showModal)="onShowModal($event)"
      (logoutClick)="onLogout()"
    />

    @if (hasSelected()) {
      <app-message-panel (back)="onBack()" />
    } @else {
      <app-no-selected-chat />
    }

    @if (modalName() === 'new-chat') {
      <app-new-chat-modal (closeModal)="onShowModal('')" />
    }
  </div>

  @if (loggingOut()) {
    <div class="logout-overlay" role="status" aria-live="polite" aria-busy="true">
      <span class="logout-overlay__spinner" aria-hidden="true"></span>
      <span>Cerrando sesión…</span>
    </div>
  }
</section>
